<!--
 * @FileDescription: 提现管理
 * @Author: xy（作者）
 * @Date: 2020-12-31（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">
          <div class="grade-top">
               <a-input  class="market-input" v-model="keyword" placeholder="请输入用户手机号"  @pressEnter="onSearch()" />
                <a-button class="button-search" @click.stop="onSearch()">筛选</a-button>
                <a-button class="button-search1" @click.stop="onRest(1)">重置</a-button>
          </div>
          <div class="line"></div>
           <div class="market-tab">
                <div class="market-tab-item" :class="tabindex == 0 ? 'market-tab-item-active':''" @click="changTab(0)">
                    <img src="@/assets/image/adjustment-img4.png" alt="" v-if="tabindex == 0">
                    <img src="@/assets/image/adjustment-img1.png" alt="" v-else>
                    全部
                </div>
                 <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 1 ? 'market-tab-item-active':''" @click="changTab(1)">
                    <img src="@/assets/image/shenpi.png" alt="" v-if="tabindex == 1">
                    <img src="@/assets/image/shenpi1.png" alt="" v-else>
                    待审核
                </div>
                <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 3 ? 'market-tab-item-active':''" @click="changTab(3)">
                    <img src="@/assets/image/shenpijujue.png" alt="" v-if="tabindex == 3">
                    <img src="@/assets/image/shenpijujue1.png" alt="" v-else>
                    审核驳回
                </div>
                 <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 4 ? 'market-tab-item-active':''" @click="changTab(4)">
                    <img src="@/assets/image/dakuanchenggong.png" alt="" v-if="tabindex == 4">
                    <img src="@/assets/image/dakuanchenggong1.png" alt="" v-else>
                    审核通过已付款
                </div>
                 <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 2 ? 'market-tab-item-active':''" @click="changTab(2)">
                    <img src="@/assets/image/dakuanshibai.png" alt="" v-if="tabindex == 2">
                    <img src="@/assets/image/dakuanshibai1.png" alt="" v-else>
                    审核通过待付款
                </div>
            </div>
            <a-table :columns="columns"
                     :dataSource="dataSource"
                     :pagination="false"
                     :scroll="{y: 'calc(100vh - 320px)' }"
                     class="table-log-height"
                     bordered
                     rowKey="key">
                <template slot="state" slot-scope="text, record, index">
                    <div class="state-titile">
                         <span v-if="record.state == 1 || record.state == 2" class="state-cir"></span>
                         <span v-if="record.state == 4" class="state-cir state-cir1"></span>
                         <span v-if="record.state == 3" class="state-cir state-cir2"></span>
                        <span v-if="record.state == 1" style="color:#f76f14;">待审核</span>
                        <span v-if="record.state == 2">审核通过待付款</span>
                        <div class="state-flex" v-if="record.state == 3">
                            <span>审核驳回</span>
                            <a-tooltip>
                                <template slot="title">
                               {{record.reason}}
                                </template>
                                <span class="state-result">原因：{{record.reason}}</span>
                            </a-tooltip>
                        </div>
                        <span v-if="record.state == 4">审核通过已付款</span>
                    </div>
                </template>
                <template slot="operation" slot-scope="text, record, index">
                   <span class="set-goods" @click="ondetail(record,2)"  style="margin-right:10px" v-if="record.state == 1">同意申请</span>
                   <span class="set-goods" @click="ondetail(record,3)" v-if="record.state == 1">拒绝申请</span>
                </template>
            </a-table>
             <div class="pagination-footer-box">
                <a-pagination :total="pagination.total" :page-size="pagination.pageSize" :default-current="pagination.current"
                    :show-total="pagination.showTotal" @showSizeChange="onShowSizeChange" @change="handleTableChange"
                    show-size-changer show-quick-jumper />
            </div>
      </div>
        <a-modal :title="title" v-model="visible" @ok="handleOk"  @cancel="onCancel"  class="red-dashed-model">
            <div class="red-dashed-box">
                <textarea placeholder="请输入理由" v-model="textarea" cols="30" rows="10" ref="inputs" @keyup.enter="handleOk" class="textarea-text"></textarea>
            </div>
        </a-modal>
         <a-modal :title="titleSuc" v-model="visibleSuc" @ok="handleOkSuc"  @cancel="onCancel"  class="red-dashed-model1">
            <div class="cancel-out-image1">
                <img src="@/assets/image/tishi.png" alt="" class="image">
               您是否确定要同意？
            </div>
         </a-modal>
  </div>
</template>
<script>
import {withdrawState} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import {method} from './method/method'
export default {
    mixins:[mixins,method],
    data(){
        return{
            title:'拒绝申请',
            keyword:'',
            tabindex:0,
            visible:false,
            visibleSuc:false,
            titleSuc:'同意申请',
            textarea:'',
            tablabel:'',
            recordItem:{},
            columns: [
                {
                    title: '',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 70,
                    align: 'center',
                    customRender(t, r, index) {
                        return parseInt(index) + 1
                    }
                },
                {
                    title: '申请用户',
                    key: 'mobile',
                    dataIndex: 'mobile',
                    width:100,
                },
                {
                    title: '申请编号',
                    key: 'code',
                    dataIndex: 'code',
                    width:150,
                    ellipsis: true,
                },
                {
                    title: '申请时间',
                    key: 'createTime',
                    dataIndex: 'createTime',
                    width:150,
                    ellipsis: true,
                },
                {
                    title: '金额',
                    align:'right',
                    key: 'withdrawApplyTotal',
                    dataIndex: 'witdrawApplyTotal',
                    width:100,
                },
                {
                    title: '提现账户类型',
                    key: 'channel',
                    dataIndex: 'channel',
                    width:100,
                    customRender(t, r, index) {
                        return t==1 ? '支付宝' : t==2 ? '微信支付' :'零钱账户'
                    }
                },
                {
                    title: '审核时间',
                    key: 'auditTime',
                    dataIndex: 'auditTime',
                    width:150,
                    ellipsis: true,
                },
                {
                    title: '支付时间',
                    key: 'paymentTime',
                    dataIndex: 'paymentTime',
                    width:150,
                    ellipsis: true,
                },
                {
                    title: '支付单号',
                    key: 'channelOrderNumber',
                    dataIndex: 'channelOrderNumber',
                    width:150,
                    ellipsis: true,
                },
                {
                    title: '状态',
                    key: 'state',
                    dataIndex:'state',
                    width:200,
                    scopedSlots: { customRender: 'state' },
                },
                {
                    title: '操作',
                    key: 'operation',
                    dataIndex:'operation',
                    width:200,
                    scopedSlots: { customRender: 'operation' },
                },
            ],
            dataSource: [],
        }
    },
    watch: {

    },
    mounted () {
        this.getmessagedata()
    },
    created () {

    },
    components: {


    },
    activated(){
        if(this.$route.query.id){
            this.keyword = this.$route.query.id
            this.getmessagedata()
        }
    },
    methods: {
         /**
        * @description: 此为方法注释（方法描述）
        */
        getmessagedata(){
            this.getmessageobj('/mall-account/web/withdrawal/pageWithdrawalAuditList',{   
                    companyStoreId:this.$store.state.shopId,
                    pageNo:this.pagination.current,
                    pageSize:this.pagination.pageSize,
                    keywords:this.keyword,
                    state:this.tabindex
                },{})
        },
        /**
        * @description: 筛选
        */
        onSearch(){
            this.getmessagedata()
        },
         /**
        * @description: 重置
        */
        onRest(){
            this.keyword = ''
            this.pagination.current = 1
            this.getmessagedata()
        },
        changTab(index){
            this.tabindex = index
            this.getmessagedata()
        },
        handleOk(){
            withdrawState({
                companyStoreId:this.$store.state.shopId,
                state:this.tablabel,
                withdrawalApplyId:this.recordItem.id,
                reason:this.textarea
            },{}).then((res)=>{
                if(res.success){
                    this.onCancel()
                    this.getmessagedata()
                    this.$message.success(res.logMessage)
                }else{
                     this.onCancel()
                    this.$message.warn(res.logMessage)
                }
            })
        },
        handleOkSuc(){
            this.handleOk()
        },
        onCancel(){
            this.visible = false
            this.visibleSuc = false
        },
        ondetail(record,index){
            this.recordItem = record
            this.tablabel = index
            if(index == 2){
                this.visibleSuc = true
            }else{
                this.visible = true
            }
        }
    },

}
</script>
<style lang="scss" >
.red-dashed-model1{
    width: 400px !important;
    height: 250px;
    .cancel-out-image1{
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            width: 24px !important;
            height: 24px !important;
            margin-right: 16px !important;
        }
    }
}
.red-dashed-model{
    width: 560px !important;
    .ant-modal-content {
    height: 330px;
    border-radius: 10px;
    .ant-modal-header {
      border-radius: 10px 10px 0 0;
    }
    .ant-modal-body {
      height: 175px;
      display: flex;
      justify-content: center;
      padding: 15px 0 0 0;
    }

    .red-dashed-box {
      width: 420px;
      height: 136px;
      .textarea-text {
        width: 420px;
        height: 136px;
        padding: 10px;
        background: rgba(250, 250, 250, 1);
        border: 1px solid rgba(230, 230, 230, 1);
        border-radius: 2px;
        font-size: 14px;
        line-height: 1.5;
        outline: none;
      }
      ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #aaaaaa;
        font-size: 14px;
      }

      ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #aaaaaa;
        font-size: 14px;
      }

      :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #aaaaaa;
        font-size: 14px;
      }
    }
  }
}
</style>
<style scoped lang="scss">
.page-container-height{
    background: #ffffff;
    .grade-top{
        height: 80px;
        display: flex;
        align-items: center;
        padding-left: 30px;
        .market-input{
            width: 260px;
            margin-right: 10px;
        }
    }
    .market-tab{
        padding: 10px 30px;
        display: flex;
        align-items: center;
        .market-tab-item{
            color: #919191;
            font-size: 16px;
            img{
                width: 32px;
                height: 32px;
                margin-right: 10px;
            }
        }
        .market-tab-item-active{
            color: #387bfc;
        }
        .market-tab-line{
            width: 1px;
            height: 18px;
            background: #919191;
            margin: 0 30px;
        } 
    }
}
.state-titile{
    display: flex;
    align-items: center;
}
.state-cir{
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #f76f14;
    margin-right: 10px;
}
.state-cir1{
     background: #35ad00;
}
.state-cir2{
    background: #f0320c;
}
.state-flex{
    display: flex;
    flex-direction: column;
    .state-result{
        width: 180px;
        color:#387bfc;
        display: inline-block;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
}
.set-goods{
    color: #387bfc;
    cursor: pointer;
}
</style>
